import { call, put, takeEvery } from "redux-saga/effects";
import { sagaActions } from "./sagaActions";
import { getSmsMessageLogSuccess, initiateSmsMessageLogLoader } from "../redux/reducers/reducerSlices/SmsMessageLogReducer";
import { Uchain } from "../redux/api/agent";
import { findLastKey } from "lodash-es";

function* getSmsMessageLogSaga(action) {
    try {
        yield put(initiateSmsMessageLogLoader(true));
        const response = yield call(Uchain.getSmsMessageLogApi, action.payload);
        yield put(getSmsMessageLogSuccess(response));
    } catch (e) {
        console.log(e);
        yield put(initiateSmsMessageLogLoader(findLastKey));
    }
}

export function* smsMessageLogSagaWatcher() {
    yield takeEvery(sagaActions.GET_SMS_MESSAGE_LOG, getSmsMessageLogSaga);
}